"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooManyRequestsError = void 0;
const ResponseError_1 = require("./ResponseError");
class TooManyRequestsError extends ResponseError_1.ResponseError {
    constructor(message = "Too Many Requests", errorDescriptions = []) {
        super("TooManyRequests error.", message, 429, errorDescriptions);
    }
}
exports.TooManyRequestsError = TooManyRequestsError;
//# sourceMappingURL=TooManyRequestsError.js.map